import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleError, MyAxios } from '@services/SettingAxios';
import { wrapperFetchCheckedValidateToken } from '@sharedHelpers/wrapperFetchCheckedValidateToken';
import { ServiceCookies } from '@services/ServiceCookies';
import { autoType, autoQuery } from '../types/autoUserSchema';

export const fetchUpdateUserAuto = createAsyncThunk<autoType, autoQuery>('autoUser/fetchUpdateUserAuto', async query => {
  return await wrapperFetchCheckedValidateToken(async () => {
    return await MyAxios.patch(
      `/api/user/car/default?carRn=${query.autoRn}`,
      {},
      {
        headers: {
          [ServiceCookies.JWT_HEADER]: ServiceCookies.jwtAccess,
        },
      },
    )
      .then(() => query)
      .catch(handleError);
  });
});
